module.exports = __webpack_public_path__ + "static-v-shop/1765576151267/img/logo_maestro.ced7dab5.png";